import MarkdownIt from 'markdown-it';
import markdownItContainer from 'markdown-it-container';
import taskLists from 'markdown-it-task-lists';
import footnote from 'markdown-it-footnote';

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true
}).enable(['table'])
.use(taskLists, { disabled: false })
.use(footnote)
.use(markdownItContainer, 'tip', {
  validate: (params) => /^tip\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div style="display:flex;flex-direction:row;gap:12px;margin-top:12px;margin-bottom:32px;background:rgba(52,211,153,0.1);border:1px solid rgba(52,211,153,0.3);border-radius:12px;padding:16px;color:#34D399;line-height:1.8;align-items:flex-start"><span style="font-size:20px;flex-shrink:0;margin-top:2px">💡</span><div style="flex:1;min-width:0">';
    }
    return '</div></div>';
  }
})
.use(markdownItContainer, 'warning', {
  validate: (params) => /^warning\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div style="display:flex;flex-direction:row;gap:12px;margin-top:12px;margin-bottom:32px;background:rgba(248,113,113,0.1);border:1px solid rgba(248,113,113,0.3);border-radius:12px;padding:16px;color:#F87171;line-height:1.8;align-items:flex-start"><span style="font-size:20px;flex-shrink:0;margin-top:2px">⚠️</span><div style="flex:1;min-width:0">';
    }
    return '</div></div>';
  }
})
.use(markdownItContainer, 'button', {
  validate: (params) => /^button\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div style="display:flex;justify-content:center;align-items:center;margin:12px auto 32px auto;width:fit-content;background:#F0A500;border:2px solid #F0A500;border-radius:8px;padding:12px 16px;color:white">';
    }
    return '</div>';
  }
})
.use(markdownItContainer, 'error', {
  validate: (params) => /^error\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div style="display:flex;flex-direction:row;gap:12px;margin-top:12px;margin-bottom:32px;background:rgba(239,68,68,0.1);border:1px solid rgba(239,68,68,0.3);border-radius:12px;padding:16px;color:#EF4444;line-height:1.8;align-items:flex-start"><span style="font-size:20px;flex-shrink:0;margin-top:2px">❌</span><div style="flex:1;min-width:0">';
    }
    return '</div></div>';
  }
})
.use(markdownItContainer, 'info', {
  validate: (params) => /^info\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div style="display:flex;flex-direction:row;gap:12px;margin-top:12px;margin-bottom:32px;background:rgba(59,130,246,0.1);border:1px solid rgba(59,130,246,0.3);border-radius:12px;padding:16px;color:#3B82F6;line-height:1.8;align-items:flex-start"><span style="font-size:20px;flex-shrink:0;margin-top:2px">ℹ️</span><div style="flex:1;min-width:0">';
    }
    return '</div></div>';
  }
})
.use(markdownItContainer, 'success', {
  validate: (params) => /^success\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div style="display:flex;flex-direction:row;gap:12px;margin-top:12px;margin-bottom:32px;background:rgba(52,211,153,0.1);border:1px solid rgba(52,211,153,0.3);border-radius:12px;padding:16px;color:#10B981;line-height:1.8;align-items:flex-start"><span style="font-size:20px;flex-shrink:0;margin-top:2px">✓</span><div style="flex:1;min-width:0">';
    }
    return '</div></div>';
  }
})
.use(markdownItContainer, 'question', {
  validate: (params) => /^question\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div style="display:flex;flex-direction:row;gap:12px;margin-top:12px;margin-bottom:32px;background:rgba(245,158,11,0.1);border:1px solid rgba(245,158,11,0.3);border-radius:12px;padding:16px;color:#F59E0B;line-height:1.8;align-items:flex-start"><div style="width:24px;height:24px;flex-shrink:0;background:#F59E0B;border-radius:4px;display:flex;align-items:center;justify-content:center;color:white;font-weight:bold;font-size:14px">?</div><div style="flex:1;min-width:0">';
    }
    return '</div></div></div>';
  }
})
.use(markdownItContainer, 'yt', {
  validate: (params) => /^yt\b/.test(params.trim()),
  render: (tokens, idx) => {
    if (tokens[idx].nesting === 1) {
      return '<div data-yt-container style="position:relative;width:100%;padding-bottom:56.25%;height:0;margin:12px 0 32px 0;border-radius:12px;overflow:hidden">';
    }
    return '</div>';
  }
})
.use(markdownItContainer, 'details', {
  validate: (params) => /^details\b/.test(params.trim()),
  render: (tokens, idx) => {
    const token = tokens[idx];
    if (token.nesting === 1) {
      const summary = token.info.trim().slice('details'.length).trim();
      return `<details style="margin:12px 0 32px 0;padding:12px;background:rgba(59,130,246,0.05);border:1px solid rgba(59,130,246,0.2);border-radius:8px"><summary style="cursor:pointer;color:#5B9EF0;font-weight:600;padding:8px 0">${md.utils.escapeHtml(summary || 'Details')}</summary><div style="margin-top:12px;color:rgba(255,255,255,0.85)">`;
    }
    return '</div></details>';
  }
});

// Style bullet lists
md.renderer.rules.bullet_list_open = () => `<ul style='padding-left: 40px; margin: 12px 0; list-style-type: disc;'>`;
md.renderer.rules.list_item_open = function(tokens, idx) {
  const token = tokens[idx];
  if (token.attrGet('class') === 'task-list-item') {
    return `<li style='color: rgba(255,255,255,0.85); line-height: 1.6; margin-bottom: 8px; list-style-type: none; display: flex; align-items: center; gap: 8px;'>`;
  }
  return `<li style='color: rgba(255,255,255,0.85); line-height: 1.6; margin-bottom: 8px; list-style-type: disc;'>`;
};

// Custom paragraph renderer to force block display
const originalParagraphOpen = md.renderer.rules.paragraph_open;
md.renderer.rules.paragraph_open = function(tokens, idx) {
  if (originalParagraphOpen) {
    return originalParagraphOpen(tokens, idx);
  }
  return '<p style="color: rgba(255,255,255,0.85); display: block; margin: 12px 0;">';
};

export const parseMarkdown = (text) => {
  if (!text) return '';
  const styles = `<style>
    h1, h2, h3, h4, h5, h6 { padding-top: 12px; padding-bottom: 6px; }
    ul, ol { padding-left: 32px; margin: 8px 0; }
    li { margin-bottom: 6px; }
    input.task-list-item-checkbox { width: 18px; height: 18px; cursor: pointer; accent-color: #5B9EF0; margin: 0; border: 2px solid #5B9EF0; }
    .footnotes { margin-top: 32px; padding-top: 16px; border-top: 1px solid rgba(59, 130, 246, 0.2); font-size: 13px; color: #9DB4D4; }
    .footnotes ol { padding-left: 20px; }
    .footnotes li { margin-bottom: 8px; line-height: 1.6; }
    .footnotes a { color: #5B9EF0; text-decoration: none; }
    .footnotes a:hover { text-decoration: underline; }
    sup a { color: #5B9EF0; text-decoration: none; }
    sup a:hover { text-decoration: underline; }
  </style>`;
  let html = md.render(text);

  // Convert button containers to clickable links
  html = html.replace(/<div style="display:flex;justify-content:center;align-items:center;margin:12px auto 32px auto;width:fit-content;background:#F0A500;border:2px solid #F0A500;border-radius:8px;padding:12px 16px;color:white">([\s\S]*?)<\/div>/g, (match, content) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    const text = tempDiv.innerText.trim();

    const commaIndex = text.lastIndexOf(',');
    if (commaIndex > -1) {
      const label = text.substring(0, commaIndex).trim();
      const url = text.substring(commaIndex + 1).trim();

      try {
        new URL(url);
        return `<div style="display:flex;justify-content:center;align-items:center;margin:12px auto 32px auto;width:fit-content;background:#F0A500;border:2px solid #F0A500;border-radius:8px;padding:12px 16px;color:white"><a href="${url}" target="_blank" rel="noopener noreferrer" style="color:white;text-decoration:none;font-weight:600">${label}</a></div>`;
      } catch {
        return match;
      }
    }
    return match;
  });

  // Convert YouTube containers - extract URL and create iframe
  html = html.replace(/<div data-yt-container[^>]*>([\s\S]*?)<\/div>/g, (match, content) => {
    // Extract YouTube URL from content (handles youtube.com/watch?v= and youtu.be/ formats)
    let videoId = null;

    const watchMatch = content.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/);
    if (watchMatch) {
      videoId = watchMatch[1];
    }

    const shortMatch = content.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (shortMatch) {
      videoId = shortMatch[1];
    }

    if (videoId) {
      return `<div style="position:relative;width:100%;padding-bottom:56.25%;height:0;margin:12px 0 32px 0;border-radius:12px;overflow:hidden"><iframe style="position:absolute;top:0;left:0;width:100%;height:100%;border:none" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    }
    return match;
  });

  return styles + html;
};
